import { Box, CardMedia, Typography } from "@mui/material";
import ItemBullet from "assets/icons/list_bullet.svg";

export default function SkillItem({ text }) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.5,
        alignItems: "flex-start",
        marginLeft: -2,
      }}
    >
      <Box
        sx={{
          height: { xs: 32, md: 42 },
          marginTop: { xs: 0.1, md: 0 },
        }}
      >
        <CardMedia component="img" src={ItemBullet} height="100%" />
      </Box>
      <Typography
        variant="p"
        sx={{
          flex: 1,
          fontFamily: "Poppins",
          fontWeight: 500,
          fontSize: { xs: 14, md: 16 },
          textShadow: "0px 4px 4px rgba(255, 255, 255, 0.25)",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
